// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/DriveHost.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { StringValue } from "../../google/protobuf/wrappers";
import { ShardChunk, ShardInfo } from "./Models/DriveModels";

export const protobufPackage = "daisi.protos.v1";

export interface StoreShardResponse {
  Success: boolean;
  Error?: string | undefined;
}

export interface RetrieveShardRequest {
  ShardId: string;
}

export interface DeleteShardRequest {
  ShardId: string;
}

export interface DeleteShardResponse {
  Success: boolean;
}

export interface ListShardsRequest {
}

export interface ListShardsResponse {
  Shards: ShardInfo[];
  TotalStorageUsed: Long;
  MaxStorageCapacity: Long;
}

function createBaseStoreShardResponse(): StoreShardResponse {
  return { Success: false, Error: undefined };
}

export const StoreShardResponse: MessageFns<StoreShardResponse> = {
  encode(message: StoreShardResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Error !== undefined) {
      StringValue.encode({ value: message.Error! }, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StoreShardResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStoreShardResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Error = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StoreShardResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Error: isSet(object.Error) ? String(object.Error) : undefined,
    };
  },

  toJSON(message: StoreShardResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Error !== undefined) {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StoreShardResponse>, I>>(base?: I): StoreShardResponse {
    return StoreShardResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StoreShardResponse>, I>>(object: I): StoreShardResponse {
    const message = createBaseStoreShardResponse();
    message.Success = object.Success ?? false;
    message.Error = object.Error ?? undefined;
    return message;
  },
};

function createBaseRetrieveShardRequest(): RetrieveShardRequest {
  return { ShardId: "" };
}

export const RetrieveShardRequest: MessageFns<RetrieveShardRequest> = {
  encode(message: RetrieveShardRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ShardId !== "") {
      writer.uint32(10).string(message.ShardId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RetrieveShardRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRetrieveShardRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ShardId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RetrieveShardRequest {
    return { ShardId: isSet(object.ShardId) ? globalThis.String(object.ShardId) : "" };
  },

  toJSON(message: RetrieveShardRequest): unknown {
    const obj: any = {};
    if (message.ShardId !== "") {
      obj.ShardId = message.ShardId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RetrieveShardRequest>, I>>(base?: I): RetrieveShardRequest {
    return RetrieveShardRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RetrieveShardRequest>, I>>(object: I): RetrieveShardRequest {
    const message = createBaseRetrieveShardRequest();
    message.ShardId = object.ShardId ?? "";
    return message;
  },
};

function createBaseDeleteShardRequest(): DeleteShardRequest {
  return { ShardId: "" };
}

export const DeleteShardRequest: MessageFns<DeleteShardRequest> = {
  encode(message: DeleteShardRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ShardId !== "") {
      writer.uint32(10).string(message.ShardId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteShardRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteShardRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ShardId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteShardRequest {
    return { ShardId: isSet(object.ShardId) ? globalThis.String(object.ShardId) : "" };
  },

  toJSON(message: DeleteShardRequest): unknown {
    const obj: any = {};
    if (message.ShardId !== "") {
      obj.ShardId = message.ShardId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteShardRequest>, I>>(base?: I): DeleteShardRequest {
    return DeleteShardRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteShardRequest>, I>>(object: I): DeleteShardRequest {
    const message = createBaseDeleteShardRequest();
    message.ShardId = object.ShardId ?? "";
    return message;
  },
};

function createBaseDeleteShardResponse(): DeleteShardResponse {
  return { Success: false };
}

export const DeleteShardResponse: MessageFns<DeleteShardResponse> = {
  encode(message: DeleteShardResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteShardResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteShardResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteShardResponse {
    return { Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false };
  },

  toJSON(message: DeleteShardResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteShardResponse>, I>>(base?: I): DeleteShardResponse {
    return DeleteShardResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteShardResponse>, I>>(object: I): DeleteShardResponse {
    const message = createBaseDeleteShardResponse();
    message.Success = object.Success ?? false;
    return message;
  },
};

function createBaseListShardsRequest(): ListShardsRequest {
  return {};
}

export const ListShardsRequest: MessageFns<ListShardsRequest> = {
  encode(_: ListShardsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListShardsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListShardsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ListShardsRequest {
    return {};
  },

  toJSON(_: ListShardsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ListShardsRequest>, I>>(base?: I): ListShardsRequest {
    return ListShardsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListShardsRequest>, I>>(_: I): ListShardsRequest {
    const message = createBaseListShardsRequest();
    return message;
  },
};

function createBaseListShardsResponse(): ListShardsResponse {
  return { Shards: [], TotalStorageUsed: Long.ZERO, MaxStorageCapacity: Long.ZERO };
}

export const ListShardsResponse: MessageFns<ListShardsResponse> = {
  encode(message: ListShardsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Shards) {
      ShardInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    if (!message.TotalStorageUsed.equals(Long.ZERO)) {
      writer.uint32(16).int64(message.TotalStorageUsed.toString());
    }
    if (!message.MaxStorageCapacity.equals(Long.ZERO)) {
      writer.uint32(24).int64(message.MaxStorageCapacity.toString());
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListShardsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListShardsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Shards.push(ShardInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalStorageUsed = Long.fromString(reader.int64().toString());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.MaxStorageCapacity = Long.fromString(reader.int64().toString());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListShardsResponse {
    return {
      Shards: globalThis.Array.isArray(object?.Shards) ? object.Shards.map((e: any) => ShardInfo.fromJSON(e)) : [],
      TotalStorageUsed: isSet(object.TotalStorageUsed) ? Long.fromValue(object.TotalStorageUsed) : Long.ZERO,
      MaxStorageCapacity: isSet(object.MaxStorageCapacity) ? Long.fromValue(object.MaxStorageCapacity) : Long.ZERO,
    };
  },

  toJSON(message: ListShardsResponse): unknown {
    const obj: any = {};
    if (message.Shards?.length) {
      obj.Shards = message.Shards.map((e) => ShardInfo.toJSON(e));
    }
    if (!message.TotalStorageUsed.equals(Long.ZERO)) {
      obj.TotalStorageUsed = (message.TotalStorageUsed || Long.ZERO).toString();
    }
    if (!message.MaxStorageCapacity.equals(Long.ZERO)) {
      obj.MaxStorageCapacity = (message.MaxStorageCapacity || Long.ZERO).toString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListShardsResponse>, I>>(base?: I): ListShardsResponse {
    return ListShardsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListShardsResponse>, I>>(object: I): ListShardsResponse {
    const message = createBaseListShardsResponse();
    message.Shards = object.Shards?.map((e) => ShardInfo.fromPartial(e)) || [];
    message.TotalStorageUsed = (object.TotalStorageUsed !== undefined && object.TotalStorageUsed !== null)
      ? Long.fromValue(object.TotalStorageUsed)
      : Long.ZERO;
    message.MaxStorageCapacity = (object.MaxStorageCapacity !== undefined && object.MaxStorageCapacity !== null)
      ? Long.fromValue(object.MaxStorageCapacity)
      : Long.ZERO;
    return message;
  },
};

export type DriveHostProtoDefinition = typeof DriveHostProtoDefinition;
export const DriveHostProtoDefinition = {
  name: "DriveHostProto",
  fullName: "daisi.protos.v1.DriveHostProto",
  methods: {
    storeShard: {
      name: "StoreShard",
      requestType: ShardChunk,
      requestStream: true,
      responseType: StoreShardResponse,
      responseStream: false,
      options: {},
    },
    retrieveShard: {
      name: "RetrieveShard",
      requestType: RetrieveShardRequest,
      requestStream: false,
      responseType: ShardChunk,
      responseStream: true,
      options: {},
    },
    deleteShard: {
      name: "DeleteShard",
      requestType: DeleteShardRequest,
      requestStream: false,
      responseType: DeleteShardResponse,
      responseStream: false,
      options: {},
    },
    listShards: {
      name: "ListShards",
      requestType: ListShardsRequest,
      requestStream: false,
      responseType: ListShardsResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface DriveHostProtoServiceImplementation<CallContextExt = {}> {
  storeShard(
    request: AsyncIterable<ShardChunk>,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<StoreShardResponse>>;
  retrieveShard(
    request: RetrieveShardRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<ShardChunk>>;
  deleteShard(
    request: DeleteShardRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<DeleteShardResponse>>;
  listShards(
    request: ListShardsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ListShardsResponse>>;
}

export interface DriveHostProtoClient<CallOptionsExt = {}> {
  storeShard(
    request: AsyncIterable<DeepPartial<ShardChunk>>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<StoreShardResponse>;
  retrieveShard(
    request: DeepPartial<RetrieveShardRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<ShardChunk>;
  deleteShard(
    request: DeepPartial<DeleteShardRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<DeleteShardResponse>;
  listShards(
    request: DeepPartial<ListShardsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ListShardsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
